// extracted by css-extract-rspack-plugin
export default {"highlight":"highlighter__highlight___atC9Z common__bold___ve4Qa"};